export default __webpack_public_path__ + "static/media/ecwid.f8798465.svg";